import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { View } from '@shared/components/View';
import { SharedStyles } from '@shared/styles';
import { MBImage } from './MBImage';
import { MBIconV2Name, MBIconV2NameMap } from './iconV2Map';
import classNames from './iconV2.module.css';

export interface MBIconV2Props {
  color?: string;
  name?: MBIconV2Name;
  size?: number;
  style?: CSSProperties;
  className?: ClassValue;
  testID?: string;
}

export function MBIconV2({ name, color, size, style, className, testID }: MBIconV2Props) {
  const icon = !isNil(name) && MBIconV2NameMap[name];
  if (!icon) {
    return null;
  }

  return (
    <View className={[classNames.iconv2, className]} style={style} vars={{ size }} testID={testID}>
      <MBImage style={SharedStyles.full} resizeMode="contain" source={icon} tintColor={color} />
    </View>
  );
}
